import { render, staticRenderFns } from "./PricingComponent.vue?vue&type=template&id=316b9f93&"
import script from "./PricingComponent.vue?vue&type=script&lang=js&"
export * from "./PricingComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports